<!-- 创建机构 -->

<template>
  <div class="c-profile-content">
    <ul class="c-profile-list c-binding-list">
      <li>
        <div class="headimg">
          <img :src="logoPreview">
        </div>
        <div class="modify-head">
          <p class="c-tips4" v-if="showCheckTips">当前信息正在审核中，预计1-3个工作日完成，请耐心等待</p>
          <Upload v-on:resetImageName="resetImageName" btnText="上传机构LOGO">
            上传机构LOGO
          </Upload>
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">营业执照</span>
        </div>
        <div class="c-profile-rt-input">
          <Upload v-on:resetImageName="resetBusinessLicense" btnText="上传营业执照" accept="image/jpeg,image/png,application/pdf">
            <button class="submit-btn">{{businessLicense===''?'上传附件':'重新上传'}}</button>
          </Upload>
          <!-- <PictureUpload :limit="1" :imageName="businessLicense" v-on:resetImageName="resetBusinessLicense">
            <button class="submit-btn">上传附件</button>
          </PictureUpload> -->
          <p class="c-tips1">上传营业执照照片:</p>
          <p class="c-tips2">照片所有信息真实可见，内容真实有效，不得做任何修改。</p>
          <div class="c-business-license">
            <img :src="businessLicensePreview">
          </div>
          <p class="c-tips3">{{businessLicense}}</p>
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">机构上云协议</span>
        </div>
        <div class="c-profile-rt-input">

          <Upload style="display: inline-block;" v-on:resetImageName="resetCloudProtocol" btnText="上传认证公函" accept="image/jpeg,image/png,application/pdf">
            <button class="submit-btn">{{cloudProtocol.length===0?'上传认证公函':'重新上传'}}</button>
          </Upload>
          <a :href="downloadProtocolPath"><span class="download-agreement">下载认证公函<img src="../../assets/main/xiazai.png"></span></a>
          <div class="c-business-license">
            <p class="c-tips3">{{cloudProtocol[0] && cloudProtocol[0].name}}</p>
          </div>
        </div>
      </li>
      <!--li>
              <p class="c-profile-lf-txt">附件</p>
              <div class="c-profile-rt-input">
                  <Upload style="display: inline-block;" v-on:resetImageName="resetAttachment" btnText="上传企业头像" >
                    <button class="submit-btn">上传附件</button>
                  </Upload>
                  <div class="c-business-license">
                      <p class="c-tips3">{{attachment[0] && attachment[0].name}}</p>
                  </div>
              </div>
          </li-->
      <li>
        <div class="c-title">
          <img src="../../assets/main/qiye1.png">
          请填写您的机构信息
        </div>
      </li>
      <li>
        <div style="display: flex;">
          <!-- <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">专业领域</div> -->
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt"><em>*</em>新基建</div>
          <!-- <NewConstructor :selectedOptions="industrycategory" v-on:dataChange="handleNewConstructorChange" /> -->
          <div class="c-profile-rt-input">
          <Wisdom :selectedOptions="industrycategory" v-on:dataChange="handleWisdomChange" />
        </div>
        </div>
       <!-- <div style="display: flex;">
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt"></div>
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">数字上云</div>
          <DigitalCloud :selectedOptions="industrycategory" v-on:dataChange="handleDigitalCloudChange" />
        </div> -->
        <!-- <div style="display: flex;">
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt"></div>
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">智慧专区</div>
          <Wisdom :selectedOptions="industrycategory" v-on:dataChange="handleWisdomChange" />
        </div>
        <div style="display: flex;">
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt"></div>
          <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">金融服务</div>
          <FinacialService :selectedOptions="industrycategory" v-on:dataChange="handleFinacialServiceChange" />
        </div>-->
        <div style="display: flex;">
          <!-- <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">地方产业</div> -->
          <IndustryDev :tag="tag" :nation="nation" v-on:dataChange="handleIndustryDevChange" />
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">法人代表</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="legalperson" type="text" placeholder="法人代表">
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">机构名称</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="organization" type="text" placeholder="机构名称">
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">机构联系人</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="contacts" type="text" placeholder="请输入联系人联系人">
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">联系电话</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="mobile" type="text" maxlength="11" placeholder="请输入联系电话">
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="item-label">座机</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="tel" type="text" maxlength="12" placeholder="请输入座机号码">
        </div>
      </li>
      <!--li>
        <p class="c-profile-lf-txt">邮编</p>
        <div class="c-profile-rt-input">
          <input v-model="zipcode" type="text" placeholder="请输入邮编">
        </div>
      </li-->
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">联系地址</span>
        </div>
        <div class="c-profile-rt-input c-profile-rt-input2">
          <div style="display: inline-block;float:left;margin-right:20px;">
            <CityCascader placeholderstr="选择省市" v-on:resetDefaultValue="setAddress" :defaultlevel1name="province"
              :defaultlevel2name="district"></CityCascader>
          </div>
          <input v-model="address" type="text" placeholder="">
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">机构简介</span>
        </div>
        <div class="c-profile-rt-input">
          <textarea v-model="orgdesc" placeholder="请输入机构简介"></textarea>
          <p class="c-tips2">机构简介不少于100字。</p>
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">统一社会信用代码</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="scc" type="text" maxlength="18" placeholder="请输入统一社会信用代码">
        </div>
      </li>
      <li>
        <div class="c-profile-lf-txt">
          <span class="need">*</span><span class="item-label">注册资本</span>
        </div>
        <div class="c-profile-rt-input">
          <input v-model="registeredcapital" type="text" placeholder="单位:万元" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')">
           &nbsp;&nbsp;万元
        </div>
       
      </li>
      <!-- <li>
              <div class="c-title">
                <img src="../../assets/main/duigongdakuan.png">
                填对公资料
              </div>
          </li>
          <li>
              <p class="c-profile-lf-txt">营业执照</p>
              <div class="c-profile-rt-input">
                  <input pla type="text" placeholder="业务名">
              </div>
          </li>
          <li>
              <p class="c-profile-lf-txt">对公账号</p>
              <div class="c-profile-rt-input">
                  <input pla type="text" placeholder="业务名">
              </div>
          </li> -->
    </ul>

    <div class="sbumit-btn-box">
      <button @click="dialogFormVisible = true" class="submit-btn">提交</button>
      <button @click="backOrg" class="submit-btn cancel-btn">取消</button>
    </div>
    <el-dialog title="信息浏览" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="机构名称" :label-width="formLabelWidth">
          <el-input v-model="organization" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="法人代表" :label-width="formLabelWidth">
          <el-input v-model="legalperson" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="专业领域" :label-width="formLabelWidth">
          <div class="org-info-item">
            <span>{{checkedWisdoms}}{{dfcy==''?'':dfcy}}{{kcpt==''?'':kcpt}}</span>
          </div>
        </el-form-item>
        <el-form-item label="机构联系人" :label-width="formLabelWidth">
          <el-input v-model="contacts" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input v-model="mobile" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="座机" :label-width="formLabelWidth">
          <el-input v-model="tel" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" :label-width="formLabelWidth">
          <el-input v-model="address" :disabled="true">
            <template slot="prepend">{{province+district}}</template></el-input>
        </el-form-item>
        <el-form-item label="机构简介" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="orgdesc" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" :label-width="formLabelWidth">
          <el-input v-model="scc" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="注册资本" :label-width="formLabelWidth">
          <el-input v-model="registeredcapital" :disabled="true"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createOrg">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import config from '@/config/index';
  import PictureUpload from '@/components/common/PictureUploader'
  import {
    addOrg,
    modifyOrg,
    getUserinfo,
  } from '@/api/personalCenter';
  import Upload from '@/components/common/Upload';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import NewConstructor from './components/NewConstructor';
  import DigitalCloud from './components/DigitalCloud';
  import Wisdom from './components/Wisdom';
  import FinacialService from './components/FinacialService';
  import IndustryDev from './components/IndustryDev';
  import OrgType from './components/OrgType'
  import CityCascader from '@/components/common/MyCascader/city'
  import {
    validScc,validateTelphone,validMobile
  } from '@/utils/validTools.js'
  import {
    Dialog,
    Button,
    Select,
    Option,
    Form,
    FormItem,
    Input
  } from 'element-ui'
  export default {
    name: 'SceneManager',
    props: {
      msg: String,
    },
    components: {
      Upload,
      NewConstructor,
      DigitalCloud,
      FinacialService,
      IndustryDev,
      Wisdom,
      OrgType,
      CityCascader,
      PictureUpload,
      [Dialog.name]: Dialog,
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Input.name]: Input
    },
    data() {
      return {
        org: null,
        downloadProtocolPath: 'http://img.yunsmartcity.com/doc/%E6%99%BA%E6%85%A7%E5%9F%8E%E5%B8%82%E4%BA%91%E7%BD%91%E5%B9%B3%E5%8F%B0%E6%9C%BA%E6%9E%84%E8%AE%A4%E8%AF%81%E5%85%AC%E5%87%BD.docx',
        logoPreview: '',
        areaSelectedOptions: [], // 默认选中地址
        orgid: '',
        businessLicensePreview: '',
        provcity: {},
        tag: {
          dfcy: '',
          kcpt: ''
        },
        dfcy: '', // 地方产业
        kcpt: '', // 科创平台
        organization: '',
        industrycategory: '',
        nation: '',
        legalperson: '',
        contacts: '',
        mobile: '',
        tel:'',
        registeredcapital: '',
        address: '',
        zipcode: '',
        province: '',
        district: '',
        attachment: [],
        logo: '',
        scc: '',
        orgdesc: '',
        // {"name":"1596607262748-机构协议.java"}
        cloudProtocol: [],
        businessLicense: '',
        binduid: 11,
        checked: 1,
        checkedNewConstructors: [],
        checkedDigitalClouds: [],
        checkedWisdoms: [],
        checkedOrgType:[],
        checkedFinacialServices: [],
        checkedIndustryDevs: [],
        showCheckTips: false,
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '120px',
      };
    },
    mounted() {
      this.queryUserInfo();
    },
    methods: {
      /**
       * 查询当前用户绑定机构信息
       */
      queryUserInfo() {
        const {
          uid
        } = getCacheUserInfo();
        this.$http.get(getUserinfo(uid)).then((res) => {
          if (res.code === 1&&res.data&&res.data.org) {
            this.org = res.data.org;
            if (this.org.checked === 0) {
              this.showCheckTips = true;
            } else {
              this.showCheckTips = false;
            }
          }
          this.initData();
        });
      },
      /**
       * 初始化数据、格式化数据
       */
      initData() {
        if (this.org) {
          const keys = Object.keys(this.org);
          keys.forEach((key) => {
            this[key] = this.org[key];
          });
          if (this.tag && typeof this.tag === 'string') {
            this.tag = JSON.parse(this.tag);
            this.dfcy = this.tag && this.tag.dfcy;
            this.kcpt = this.tag && this.tag.kcpt;
          }
          if (this.cloudProtocol && typeof this.cloudProtocol === 'string') {
            this.cloudProtocol = JSON.parse(this.cloudProtocol);
          }
          if (this.attachment && typeof this.attachment === 'string') {
            this.attachment = JSON.parse(this.attachment);
          }

          if (this.logo) {
            this.resetImageName(this.logo);
          } else {
            this.resetImageName('assets/orghead.png')
          }
          if (this.businessLicense) {
            this.businessLicensePreview = `${config.HOST_IMG}${this.businessLicense}`;
          }
          if (this.province) {
            this.areaSelectedOptions.push(this.province);
          }
          if (this.district) {
            this.areaSelectedOptions.push(this.district);
          }
        } else {
          console.log('assets/orghead.png')
          this.resetImageName('assets/orghead.png')
        }
      },
      setAddress(address) {

        this.provcity = address;
        console.log(address);
        console.log("father get provcity .");
        console.log(this.provcity.provName, this.provcity.areaName, this.provcity.provId, this.provcity.areaId);
        this.province = this.provcity.provName;
        this.district = this.provcity.areaName;
        /* if (address) {
            this.province = address[0];
            this.district = address[1];
        } */
      },
      handleNewConstructorChange(param) {
        console.log("handleNewConstructorChange",param)
        // this.checkedNewConstructors = param.checked || [];
        this.checkedOrgType = param.checked||[]
      },
      handleDigitalCloudChange(param) {
        this.checkedDigitalClouds = param.checked || [];
      },
      handleWisdomChange(param) {
        console.log("handleWisdomChange",param)
        this.checkedWisdoms = param.checked || [];
        console.log("checkedWisdoms", this.checkedWisdoms)
      },
      handleFinacialServiceChange(param) {
        this.checkedFinacialServices = param.checked || [];
      },
      handleIndustryDevChange({
        checked,
        nation,
        dfcy,
        kcpt
      }) {
        console.log(checked,
        nation,
        dfcy,
        kcpt)
        this.checkedIndustryDevs = checked;
        this.nation = nation;
        this.dfcy = dfcy;
        this.kcpt = kcpt;
      },
      getCheckedCategories() {
        // return [...this.checkedWisdoms, ...this.checkedNewConstructors, ...this.checkedDigitalClouds, ...this.checkedFinacialServices];
        console.log('getCheckedCategories',this.checkedWisdoms)
        return this.checkedWisdoms
      },
      resetImageName(key) {
        this.logo = key;
        this.logoPreview = `${config.HOST_IMG}${key}`;
      },
      resetBusinessLicense(key) {
        this.businessLicense = key//JSON.stringify(key);
        this.businessLicensePreview = `${config.HOST_IMG}${key}`;
      },
      resetCloudProtocol(key) {
        const protocol = [{
          name: key,
        }];
        this.cloudProtocol = protocol;
      },
      resetAttachment(key) {
        const attachment = [{
          name: key,
        }];
        this.attachment = attachment;
      },
      backOrg() {
        this.$router.push('org');
      },
      getUid() {
        const userInfo = getCacheUserInfo();
        const uid = userInfo && userInfo.uid;
        return uid;
      },
      getParams() {
        const uid = this.getUid();
        let {
          cloudProtocol,
          attachment
        } = this;

        if (typeof cloudProtocol !== 'string') {
          cloudProtocol = JSON.stringify(this.cloudProtocol);
        }
        if (typeof attachment !== 'string') {
          attachment = JSON.stringify(this.attachment);
        }
        if (!this.businessLicense) {
          this.$message.error('请上传营业执照或者其他主体资格证明文件');
          return null;
        }

        if (this.cloudProtocol.length <= 0) {
          this.$message.error('请上传机构上云协议');
          return null;
        }
        if(this.dfcy === ''){
          this.$message.error('请勾选地方产业')
          return null;
        }
        if(this.kcpt === ''){
          this.$message.error('请勾选地区国别')
          return null;
        }

        if (this.getCheckedCategories().length <= 0) {
          this.$message.error('请勾选机构新基建分类');
          return null;
        }
        if (!this.legalperson) {
          this.$message.error('请输入法人姓名');
          return null;
        }
        if (!this.organization) {
          this.$message.error('请输入机构名称');
          return null;
        }
        if (!this.contacts) {
          this.$message.error('请输入机构联系人姓名');
          return null;
        }
        if (!this.mobile) {
          this.$message.error('请输入机构联系人联系电话');
          return null;
        }
        if(!validMobile(this.mobile)){
          this.$message.error('请输入正确的手机号码')
          return null;
        }

        if(this.tel!==''&&!validateTelphone(this.tel)){
          this.$message.error('请输入正确的座机号')
          return null;
        }
        if (!this.province || !this.district) {
          this.$message.error('请选择省市');
          return null;
        }
        if (!this.address) {
          this.$message.error('请输入联系地址');
          return null;
        }
        if (!this.orgdesc) {
          this.$message.error('请输入机构简介');
          return null;
        }
        if (this.orgdesc.length<100) {
          this.$message.error('机构简介不少于100个字');
          return null;
        }
        if (!this.scc) {
          this.$message.error('请输入社会统一信用代码');
          return null;
        }
        if (!validScc(this.scc)) {
          this.$message.error('请输入正确的社会统一信用代码');
          return null;
        }
        if (!this.registeredcapital) {
          this.$message.error('请输入注册资本');
          return null;
        }


        let params = {
          organization: this.organization,
          industrycategory: this.getCheckedCategories().join(';'),
          nation: this.nation,
          legalperson: this.legalperson,
          contacts: this.contacts,
          mobile: this.mobile,
          tel:this.tel,
          registeredcapital: this.registeredcapital,
          address: this.address,
          province: this.province,
          district: this.district,
          logo: this.logo,
          scc: this.scc,
          orgdesc: this.orgdesc,
          cloudProtocol: cloudProtocol,
          businessLicense: this.businessLicense,//JSON.parse(this.businessLicense)[0],
          binduid: uid,
          zipcode: this.zipcode,
          attachment: attachment,
          tag: JSON.stringify({
            dfcy: (this.dfcy && this.dfcy.join) ? this.dfcy.join(';') : '',
            kcpt: (this.kcpt && this.kcpt.join) ? this.kcpt.join(';') : ''
          }),
        };
        if (this.orgid !== '') {
          params.orgid = this.orgid
        }
        return params
      },
      createOrg() {
        this.dialogFormVisible = false;
        const uid = this.getUid();
        if (!uid) {
          this.$router.push('login');
        }
        const params = this.getParams();
        if (!params) {
          return;
        }
        if (params.orgid) {
          this.updateOrg();
          return;
        }
        this.$http.post(addOrg(), params).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success('信息提交成功，等待审核');
            this.$router.push('org');
          }
        });
      },
      updateOrg() {
        const params = this.getParams();

        this.$http.post(modifyOrg(), params).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success('信息提交成功，等待审核');
            this.$router.push('org');
          }
        });
      },

    },
  };
</script>

<style scoped>
  @import url(./main.css);

  .need {
    color: red;
    padding-right: 10px;
    vertical-align: middle;
  }

  .submit-btn {
    margin: 0;
  }

  .cancel-btn {
    margin-left: 20px;
  }

  .sbumit-btn-box {
    padding: 30px;
  }

  .c-profile-lf-txt {
    width: 100px;
  }
</style>
